export default function Marquee({ items }) {
  const list = items && items.length ? items : ["Pendidikan", "Karakter", "Jepang", "Bisnis", "Kepemimpinan", "Refleksi"];
  const strip = (hidden) => (
    <div aria-hidden={hidden || undefined} className="flex items-center shrink-0">
      {list.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="font-serif italic text-lg sm:text-xl text-sub px-6 whitespace-nowrap">{item}</span>
          <span className="w-2 h-2 rounded-full bg-enji/80 shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="marquee-band" className="marquee overflow-hidden border-y border-line py-5 select-none">
      <div className="marquee-track">
        {strip(false)}
        {strip(true)}
      </div>
    </div>
  );
}

